import { useCart } from "./useCart"
import { useStore } from "./useStore"

export const useSelectedStore = () => {
  const { cart } = useCart()
  const { store } = useStore(cart.storeId)

  return { store }
}
